import { Record } from "immutable";

const defaults = {
  displayName: "",
  id: "",
  name: "",
  value: "",
};

export class UserAttributeModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown) {
    const { displayName, id, name, value } = data as typeof defaults;
    return new UserAttributeModel({
      displayName,
      id,
      name,
      value,
    });
  }
}
